import React, { useState } from 'react';

const Reglamento: React.FC = () => {
  const [accepted, setAccepted] = useState<boolean>(false);

  const handleAccept = () => {
    setAccepted(true);
  };

  const paragraph = `
   El Reglamento Interno de Trabajo, tal como lo define el artículo 104 del Código Sustantivo del Trabajo, es un documento en el cual las empresas reúnen las circunstancias y condiciones sobre las cuales se regirá el desarrollo de las labores que se prestan por parte de los trabajadores al empleador.

Artículo 104: Definición de Reglamento Interno de Trabajo: Reglamento de trabajo es el conjunto de normas que determinan las condiciones a que deben sujetarse el empleador y sus trabajadores en la prestación del servicio.

Del mismo modo, el RIT debe contener además, las obligaciones que tendrán tanto los trabajadores, el empleador, dentro de la relación laboral. Lo anterior, tal como lo indicó la Corte Constitucional en su Sentencia C 934 de 2004:

“…El reglamento de trabajo así concebido no se circunscribe tan sólo a regular la actividad desplegada por el trabajador sino una serie de situaciones jurídicas que obligan tanto a este como al empleador…”.

La empresa de servicios públicos domiciliarios , se permite publicar el reglamento interno de trabajo de los funcionarios de planta de la entidad:
  `;

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center p-2">
      <div className="w-full max-w-2xl bg-white rounded-lg shadow-lg p-10">
        <h2 className="text-2xl font-bold mb-4">Reglamento Interno de Trabajo</h2>
        <textarea
          className="w-full p-2 border border-gray-300 rounded-lg mb-2"
          rows={20}
          readOnly
          value={paragraph}
        ></textarea>
        <button
          onClick={handleAccept}
          className="bg-blue-500 text-white px-4 py-2 rounded-full w-full"
        >
          Acepto
        </button>
        {accepted && <p className="mt-4 text-green-500">Has aceptado el reglamento interno de trabajo.</p>}
      </div>
    </div>
  );
};

export default Reglamento;
